<template>
  <div>
    <!-- 报名截止 -->
    <div class="msg-box">
      <div class="icon">
        <van-icon name="warning" size="40" color="#ff976a" />
      </div>
      <p class="desc">
        活动报名已截止，感谢您的关注，期待您的下次参与！
      </p>
    </div>
  </div>
</template>
<script>
export default {};
</script>

<style lang="less" scoped>
// 默认落地页
.msg-box {
  margin-top: 20vh;
  padding: 0 20px;
  .icon {
    text-align: center;
  }
  .desc {
    padding: 20px 0;
    text-align: center;
    line-height: 30px;
  }
}
</style>
